import React from 'react'

export function TableDescription({betterOrWorse}) {
  return (
    <p className={`table-description ${betterOrWorse}`}>
        List of measures performing significantly <em>{betterOrWorse}</em> for the selected aggregation type
    </p>
  )
}